import React from 'react';

const Modal = ({
    title,
    modalId,
    bodyText,
    buttonText,
    buttonFunc,
    closeOnConfirm = true,
    disableConfirm = false,
    disableClose = false
}) => {
    const confirmDismissProps = closeOnConfirm && !disableConfirm
        ? { 'data-dismiss': 'modal' }
        : {};

    const closeDismissProps = !disableClose
        ? { 'data-dismiss': 'modal' }
        : {};

    return (

        <div className="modal fade" id={modalId} aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <span
                            className="fa fa-times clickable"
                            aria-label="Close"
                            style={disableClose ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
                            {...closeDismissProps}
                        ></span>
                    </div>
                    <div className="modal-body">
                        {bodyText}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-danger"
                            disabled={disableClose}
                            {...closeDismissProps}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={buttonFunc}
                            className="btn btn-success"
                            disabled={disableConfirm}
                            {...confirmDismissProps}
                        >
                            {buttonText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;